/* =========================================================
   cosmic syrup · main theme JS
   - mobile menu
   - transmissions carousel
   - newsletter dual-submit (Shopify + Klaviyo)
   - add-to-bag with UFO animation + cart count update
   - cart line item quantity updates
   ========================================================= */
(function () {
  'use strict';

  /* ---------- mobile menu ---------- */
  var menuBtn = document.getElementById('csMenuBtn');
  var mobileMenu = document.getElementById('csMobileMenu');
  var menuClose = document.getElementById('csMobileMenuClose');
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', function () {
      mobileMenu.hidden = false;
      requestAnimationFrame(function () { mobileMenu.classList.add('is-open'); });
      menuBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });
    function closeMenu() {
      mobileMenu.classList.remove('is-open');
      menuBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(function () { mobileMenu.hidden = true; }, 400);
    }
    if (menuClose) menuClose.addEventListener('click', closeMenu);
    mobileMenu.addEventListener('click', function (e) {
      if (e.target === mobileMenu || e.target.tagName === 'A') closeMenu();
    });
  }

  /* ---------- transmissions carousel · scroll-based controls ---------- */
  document.querySelectorAll('.cs-transmissions').forEach(function (section) {
    var track = section.querySelector('.cs-transmissions__track');
    var btns = section.querySelectorAll('.cs-transmissions__btn');
    if (!track) return;
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = btn.getAttribute('data-direction');
        var item = track.querySelector('.cs-transmissions__item');
        var step = item ? item.getBoundingClientRect().width + 20 : 280;
        track.scrollBy({ left: dir === 'next' ? step : -step, behavior: 'smooth' });
      });
    });
  });

  /* ---------- newsletter · dual submit (Shopify + Klaviyo) ---------- */
  var newsletterForm = document.getElementById('csNewsletterForm');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (e) {
      /* Shopify form will submit normally (full page redirect or follow-up).
         Fire Klaviyo subscription in parallel via fetch · doesn't block Shopify submit.
         Klaviyo creds live on the wrapping .cs-newsletter section so Liquid doesn't have to
         pass them through the form tag (which doesn't accept hyphenated data attributes). */
      var wrapper = newsletterForm.closest('.cs-newsletter');
      var companyId = wrapper ? wrapper.getAttribute('data-klaviyo-company') : '';
      var listId = wrapper ? wrapper.getAttribute('data-klaviyo-list') : '';
      var email = (newsletterForm.querySelector('input[type="email"]') || {}).value;

      if (companyId && listId && email) {
        try {
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'revision': '2024-10-15'
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  profile: { data: { type: 'profile', attributes: { email: email } } },
                  custom_source: 'cosmic syrup newsletter'
                },
                relationships: { list: { data: { type: 'list', id: listId } } }
              }
            }),
            keepalive: true
          });
        } catch (_) { /* fail silently · Shopify still receives the signup */ }
      }
      /* let Shopify form continue · do NOT preventDefault */
    });
  }

  /* ---------- add to bag · fetch API + UFO animation + cart count ---------- */
  var ufo = document.getElementById('csUfoCart');
  var cartCountEl = document.getElementById('csCartCount');
  var cartLink = document.getElementById('csCartLink');

  document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
    var form = btn.closest('form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      /* progressive enhancement · if fetch unsupported, let form submit normally */
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = 'sending...';

      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () {
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cartCountEl) {
            cartCountEl.textContent = cart.item_count;
            cartCountEl.setAttribute('data-count', cart.item_count);
          }
          announce('added to bag');
          /* UFO animation · ship flies from button toward cart icon */
          flyUfo(btn);
          btn.textContent = '✓ added';
          setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 1800);
        })
        .catch(function () {
          btn.textContent = originalText;
          btn.disabled = false;
          announce('add failed · please try again');
        });
    });
  });

  function flyUfo(fromEl) {
    if (!ufo || !cartLink) return;
    var from = fromEl.getBoundingClientRect();
    var to = cartLink.getBoundingClientRect();
    /* position ufo over button */
    ufo.style.left = (from.left + from.width / 2 - 16) + 'px';
    ufo.style.top  = (from.top + from.height / 2 - 10) + 'px';
    ufo.style.marginLeft = '0';
    /* set destination as CSS vars */
    var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
    var dy = (to.top + to.height / 2) - (from.top + from.height / 2);
    ufo.style.setProperty('--cs-ufo-x', dx + 'px');
    ufo.style.setProperty('--cs-ufo-y', dy + 'px');
    /* trail */
    var trailInterval = setInterval(function () {
      var rect = ufo.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      for (var i = 0; i < 2; i++) {
        var s = document.createElement('div');
        s.className = 'cs-ufo-trail-star';
        s.style.left = (rect.left + rect.width / 2 + (Math.random() * 12 - 6)) + 'px';
        s.style.top  = (rect.bottom + Math.random() * 14) + 'px';
        document.body.appendChild(s);
        setTimeout((function (n) { return function () { if (n.parentNode) n.parentNode.removeChild(n); }; })(s), 1000);
      }
    }, 40);
    ufo.classList.remove('flying');
    /* force reflow then re-add */
    void ufo.offsetWidth;
    ufo.classList.add('flying');
    setTimeout(function () {
      clearInterval(trailInterval);
      ufo.classList.remove('flying');
      ufo.style.cssText = '';
    }, 1500);
  }

  function announce(msg) {
    var region = document.getElementById('cart-live-region');
    if (region) region.textContent = msg;
  }

  /* ---------- cart line item quantity (no-reload update) ---------- */
  document.querySelectorAll('.cs-cart__qty').forEach(function (input) {
    var debounce;
    input.addEventListener('change', function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () {
        var key = input.getAttribute('data-key');
        var qty = parseInt(input.value, 10) || 0;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        }).then(function () { window.location.reload(); });
      }, 350);
    });
  });
  document.querySelectorAll('[data-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.getAttribute('data-remove');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () { window.location.reload(); });
    });
  });

  /* ---------- pause off-screen videos for perf ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) { v.play().catch(function(){}); }
        else { v.pause(); }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('video[autoplay]').forEach(function (v) { io.observe(v); });
  }

})();
